/**
 * ERRORS ROUTES
 */
const routes = [
  //ERROR
  {
    path: '/404',
    name: '404',
    component: 'Error/NotFoundViewComponent'
  },
  {
    path: '/network-issue',
    name: 'network-issue',
    component: 'Error/NetworkIssueViewComponent'
  },
  {
    path: '*',
    redirect: { name: '404' }
  }
];

export default routes;
